/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    AssetServiceLogCreateRequest,
    AssetServiceLogResponse,
    AssetServiceLogUpdateRequest,
    AssetServiceLogVoidRequest,
    GetServiceLogsParams,
    PagedResponseAssetServiceLogResponse
} from '../models';

export type updateServiceLogResponse200 = {
    data: AssetServiceLogResponse;
    status: 200;
};

export type updateServiceLogResponse400 = {
    data: void;
    status: 400;
};

export type updateServiceLogResponse500 = {
    data: void;
    status: 500;
};

export type updateServiceLogResponseSuccess = updateServiceLogResponse200 & {
    headers: Headers;
};

export type updateServiceLogResponseError = (
    | updateServiceLogResponse400
    | updateServiceLogResponse500
) & {
    headers: Headers;
};

export type updateServiceLogResponse =
    | updateServiceLogResponseSuccess
    | updateServiceLogResponseError;

export const getUpdateServiceLogUrl = (assetId: string, logId: string) =>
    `/api/v1/assets/${assetId}/service-logs/${logId}`;

export const updateServiceLog = async (
    assetId: string,
    logId: string,
    assetServiceLogUpdateRequest: AssetServiceLogUpdateRequest,
    options?: RequestInit
): Promise<updateServiceLogResponse> => {
    const res = await fetch(getUpdateServiceLogUrl(assetId, logId), {
        ...options,
        body: JSON.stringify(assetServiceLogUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateServiceLogResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateServiceLogResponse;
};

export type voidServiceLogResponse200 = {
    data: AssetServiceLogResponse;
    status: 200;
};

export type voidServiceLogResponse400 = {
    data: void;
    status: 400;
};

export type voidServiceLogResponse500 = {
    data: void;
    status: 500;
};

export type voidServiceLogResponseSuccess = voidServiceLogResponse200 & {
    headers: Headers;
};

export type voidServiceLogResponseError = (
    | voidServiceLogResponse400
    | voidServiceLogResponse500
) & {
    headers: Headers;
};

export type voidServiceLogResponse = voidServiceLogResponseSuccess | voidServiceLogResponseError;

export const getVoidServiceLogUrl = (assetId: string, logId: string) =>
    `/api/v1/assets/${assetId}/service-logs/${logId}/void`;

export const voidServiceLog = async (
    assetId: string,
    logId: string,
    assetServiceLogVoidRequest: AssetServiceLogVoidRequest,
    options?: RequestInit
): Promise<voidServiceLogResponse> => {
    const res = await fetch(getVoidServiceLogUrl(assetId, logId), {
        ...options,
        body: JSON.stringify(assetServiceLogVoidRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: voidServiceLogResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as voidServiceLogResponse;
};

export type getServiceLogsResponse200 = {
    data: PagedResponseAssetServiceLogResponse;
    status: 200;
};

export type getServiceLogsResponse400 = {
    data: void;
    status: 400;
};

export type getServiceLogsResponse500 = {
    data: void;
    status: 500;
};

export type getServiceLogsResponseSuccess = getServiceLogsResponse200 & {
    headers: Headers;
};

export type getServiceLogsResponseError = (
    | getServiceLogsResponse400
    | getServiceLogsResponse500
) & {
    headers: Headers;
};

export type getServiceLogsResponse = getServiceLogsResponseSuccess | getServiceLogsResponseError;

export const getGetServiceLogsUrl = (assetId: string, params?: GetServiceLogsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/assets/${assetId}/service-logs?${stringifiedParams}`
        : `/api/v1/assets/${assetId}/service-logs`;
};

export const getServiceLogs = async (
    assetId: string,
    params?: GetServiceLogsParams,
    options?: RequestInit
): Promise<getServiceLogsResponse> => {
    const res = await fetch(getGetServiceLogsUrl(assetId, params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getServiceLogsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getServiceLogsResponse;
};

export type createServiceLogResponse201 = {
    data: AssetServiceLogResponse;
    status: 201;
};

export type createServiceLogResponse400 = {
    data: void;
    status: 400;
};

export type createServiceLogResponse500 = {
    data: void;
    status: 500;
};

export type createServiceLogResponseSuccess = createServiceLogResponse201 & {
    headers: Headers;
};

export type createServiceLogResponseError = (
    | createServiceLogResponse400
    | createServiceLogResponse500
) & {
    headers: Headers;
};

export type createServiceLogResponse =
    | createServiceLogResponseSuccess
    | createServiceLogResponseError;

export const getCreateServiceLogUrl = (assetId: string) => `/api/v1/assets/${assetId}/service-logs`;

export const createServiceLog = async (
    assetId: string,
    assetServiceLogCreateRequest: AssetServiceLogCreateRequest,
    options?: RequestInit
): Promise<createServiceLogResponse> => {
    const res = await fetch(getCreateServiceLogUrl(assetId), {
        ...options,
        body: JSON.stringify(assetServiceLogCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createServiceLogResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createServiceLogResponse;
};
